import type { IconType } from "@circle-react-shared/Icon";
import { UserAction } from "./UserAction";

export interface UserActionsProps {
  actions: {
    tooltip?: string;
    icon: IconType;
    onClick: (item: any) => void;
  }[];
  item: any;
}

export const UserActions = ({ item, actions }: UserActionsProps) => {
  if (!actions) {
    return null;
  }

  return (
    <>
      {actions.map((action, index) => (
        <UserAction key={index} item={item} action={action} />
      ))}
    </>
  );
};
